import styled, {css} from "@yb/styled-px2rem";
import {SelectProps} from "@FRAMEWORK/ui/types/d";
import {ReactNode} from "react";
import IconImg from "@PUBLIC/M/images/ico/ico_spr.png";

interface Props extends SelectProps {
	width?: string;
	children: ReactNode;
	types?: string;
}

const SelectWrap = styled.div`
	position: relative;
	width: 100%;
	height: 40px;
	&::before {
		position: absolute;
		top: 50%;
		right: 16px;
		display: block;
		width: 6px;
		height: 4px;
		background: #fff url(${IconImg}) no-repeat;
		background-position: -22px 0;
		background-size: 300px 300px;
		transform: translate(0, -50%);
		content: "";
	}
`;

const StyledSelect = styled.select<{width?: string; types?: string}>`
	width: ${props => props.width || "100%"};
	height: 40px;
	line-height: 40px;
	padding: 0 30px 0 10px;
	border: 1px solid var(--line-color);
	background-color: transparent;
	font-size: 15px;
	color: var(--emp-color);

	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	outline: none;
	&::-ms-expand {
		display: none;
	}

	${props => {
		if (props.types === "calendar") {
			return css`
				border: 0;
				font-size: 21px;
				color: var(--emp-color);
			`;
		}
	}}
`;

const Select = ({width, children, ...props}: Props) => (
	<SelectWrap>
		<StyledSelect width={width} {...props}>
			{children}
		</StyledSelect>
	</SelectWrap>
);

export default Select;
